import { EventFrequency, EventOccurrence } from '@bonusly/one-on-ones-entities';

export enum QueryKey {
	CurrentOneOnOne = 'oneOnOnes_current',
	Participants = 'oneOnOnes_participants',
	Event = 'oneOnOnes_event',
	Meeting = 'oneOnOnes_meeting',
	Meetings = 'oneOnOnes_meetings',
	MeetingTimes = 'oneOnOnes_meetingTimes',
	TeamActivityDetails = 'team-activity-details',
}

export type FormValue = {
	dayOfWeek: string;
	occurrenceInMonth: EventOccurrence | null;
	frequency: EventFrequency;
	startTime: Date | null;
	endTime: Date | null;
	meetingDate: Date;
};
